import { Box, TextField } from "@mui/material";

import { SearchIcon } from "Shared/Icons/Search";

interface TableSearchInputProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
}

export const TableSearchInput = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder,
}: TableSearchInputProps): React.ReactNode => {
  return (
    <TextField
      name={name}
      id={name}
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      variant="outlined"
      slotProps={{
        input: {
          startAdornment: (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mr: 2,
              }}
            >
              <SearchIcon style={{ width: 14, height: 14, opacity: 0.5 }} />
            </Box>
          ),
        },
      }}
      sx={(theme) => ({
        "& .MuiOutlinedInput-root": {
          backgroundColor: theme.colors.backgroundTile,
          "& fieldset": {
            border: "none",
          },
        },
      })}
    />
  );
};
